import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject, { GameObjectEvent } from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import SpeechBubble from './SignSpeechBubble';
import Game from '../../Game';
import { Anim } from '../../System/Animation/AnimationHelper';
import Interactable from '../../Component/Interactable';
import Container from 'Prototype/Container';

export default class Sign extends GameObject {
    public sector: number;
    private bubbleVisible: boolean = false;
    private bubbleToggleTimeoutId: number;
    private speechBubble: SpeechBubble;

    public onCreate(params: {
        baseSprite: Sprite;
        sector: number;
        unlockLevel?: number;
        visible: boolean;
        signBubblesContainer: Container;
    }): void {
        try {
            this.sector = params.sector;

            this.addComponent<TransformComponent>(TransformComponent, params);
            this.addComponent<Renderable>(Renderable, params);

            // Add the base sprite.
            const baseSprite: Sprite = params.baseSprite;
            const transform = this.getComponent(TransformComponent);

            transform.position.copy(baseSprite.getComponent(TransformComponent).position);

            baseSprite.addComponent(Interactable, {
                enabled: true,
                buttonMode: true,
            });
            baseSprite.on(GameObjectEvent.SELECTED, this.onClick.bind(this));
            this.addChild(baseSprite);
            baseSprite.getComponent(TransformComponent).position.set(0);

            // Add the speech bubble.
            this.speechBubble = new SpeechBubble({
                speechBubbleRoot: params.baseSprite.children[0] as Sprite,
                visible: false,
                text: Game.locale
                    .getText('Level')
                    .replace('[x]', params.unlockLevel.toString()),
                textStyle: Game.style.getStyle('suitcase.text'),
            });
            params.signBubblesContainer.addChild(this.speechBubble.root);

            const bubbleTransform = this.speechBubble.root.getComponent(TransformComponent);
            bubbleTransform.position.set(transform.x, transform.y + (this.speechBubble.isUp() ? -70 : 25));
        } catch (error) {
            console.log(error);
        }
    }

    protected toggleBubble() {
        this.bubbleVisible = !this.bubbleVisible;
        const bubble: GameObject = this.speechBubble.root;

        if (!bubble?.getComponent(Renderable)) return;

        Anim(bubble, { alpha: Number(this.bubbleVisible), duration: 350 });
    }

    protected hideBubble(): void {
        if (this.bubbleVisible) {
            this.toggleBubble();
        }
    }

    protected onClick(): void {
        this.toggleBubble();
        clearTimeout(this.bubbleToggleTimeoutId);

        this.bubbleToggleTimeoutId = window.setTimeout(() => {
            this.hideBubble();
        }, 2500);
    }
}
